import React from 'react'

function FormNotification({ content, isHtml = false, status = 'alert' }) {
  return (
    <>
      {status === 'alert' ? (
        <div className="Notification Notification--withIcon Notification--withTopBorder Notification--alert u-marginBottom3gu u-animFadeInUp u-boxShadow u-marginBottom3gu">
          <hr className="Rule u-textColorAlert" />
          <div className="Notification-content">
            {isHtml ? (
              <div dangerouslySetInnerHTML={{ __html: content }}></div>
            ) : (
              <p>{content}</p>
            )}
          </div>
        </div>
      ) : (
        <div className="Notification Notification--withIcon Notification--withTopBorder Notification--warn u-marginBottom3gu u-animFadeInUp u-boxShadow u-marginBottom3gu">
          <hr className="Rule u-textColorWarning" />
          <div className="Notification-content">
            <span className="warningIcon u-textColorWarning"></span>
            {isHtml ? (
              <div dangerouslySetInnerHTML={{ __html: content }}></div>
            ) : (
              <p className="u-marginLeft3gu">{content}</p>
            )}
          </div>
        </div>
      )}
    </>
  )
}
export default FormNotification
